module.exports = __webpack_public_path__ + "static/media/Chicory.17376086.jpg";